import React, { useState, useEffect, useRef, useCallback } from "react";
import PropTypes from "prop-types";

// material ui components
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import CircularProgress from "@material-ui/core/CircularProgress";
import { DatePicker } from "@material-ui/pickers";
import { InputLabel } from "@material-ui/core";

import { useParams } from "react-router-dom";
import { usePouchDB } from "../../../components/PouchDB/PouchDBProvider";
import lodashGet from "lodash/get";
import { Swipeable } from "react-swipeable";

//icons
import ChevronRight from "@material-ui/icons/ChevronRight";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import SaveIcon from "@material-ui/icons/Save";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";

//styles
import useStyles from "./styles/keluarga";

// //hooks
// import { usePouchDB } from '../../../components/PouchDB/PouchDBProvider';
import { useSnackbar } from "notistack";

//app components
import { ScrollToTopWithoutRouter } from "../../../components/ScrollToTop";

//date utils
import formatDate from "date-fns/format";
import parseDate from "date-fns/parse";
import { countAge } from "./pk/validation";

import Swal from "sweetalert2";
import kk from "date-fns/locale/kk/index.js";
import { set } from "date-fns";
import { jenis_kelamin } from "./options";

export const formatString = "dd-MM-yyyy";

function Keluarga({
  wilayah,
  setWilayah,
  id,
  keluarga,
  setKeluarga,
  handleNext,
  handleBack,
  handleDraft,
  handleSegmen,
  handleAnomali,
  formIndex,
  mode,
  kb,
  normalizePK,
  normalizeKB,
  direction,
}) {
  const classes = useStyles();

  const nextRef = useRef(null);
  const backRef = useRef(null);
  // const { dataKK } = usePouchDB();
  const { enqueueSnackbar } = useSnackbar();
  const [error, setError] = useState({});

  const {
    user: { metadata },
    dataKK,
    dataPK,
    dataKB,
    dataBkkbn,
  } = usePouchDB();
  const [locationUser, setLocationUser] = useState([]);
  const [isSomethingChange, setSomethingChange] = useState(false);
  const [isSubmitting, setSubmitting] = useState(false);
  const [qtyKeberadaan, setQtyKeberadaan] = useState([
    { diDalamRumah: 0, diLuarRumah: 0, diLuarNegeri: 0 },
  ]);
  const [qtyMutasiAnggotaKeluarga, setQtyMutasiAnggotaKeluarga] = useState([
    { menikah: 0, meninggalDunia: 0, anggotaBaru: 0 },
  ]);
  const [isSaved, setSaved] = useState({
    local: false,
    remote: false,
  });

  // const umurnikah = countAge(selectedKeluarga.tgl_lahir) + 1;
  // const umurnikah = countAge(selectedKeluarga.tgl_lahir);

  const itemHubungan = ["Anak", "Lainnya"];
  const itemKeberadaan = ["Di Dalam Rumah", "Di Luar Rumah", "Di Luar Negeri"];
  const itemMutasiAnggotaKeluarga = [
    "Menikah",
    "Meninggal Dunia",
    "Anggota Baru",
  ];
  const [optStsPekerjaan, setOptStsPekerjaan] = useState([]);

  const defaultOptKerjaLuarNegeri = [
    { value: "1", label: "1. Pernah" },
    { value: "2", label: "2. Sedang" },
    { value: "3", label: "3. Akan (Dalam 3 Tahun Mendatang)" },
    { value: "4", label: "4. Tidak" },
  ];
  const [optKerjaLuarNegeri, setOptKerjaLuarNegeri] = useState(
    defaultOptKerjaLuarNegeri
  );

  const defaultOptJnsPendidikan = [
    { value: "1", label: "1. Tidak/Belum Sekolah" },
    { value: "2", label: "2. Tidak Tamat SD/Sederajat" },
    { value: "3", label: "3. Masih SD/Sederajat" },
    { value: "4", label: "4. Tamat SD/Sederajat" },
    { value: "5", label: "5. Tidak Tamat SMP/Sederajat" },
    { value: "6", label: "6. Masih SMP/Sederajat" },
    { value: "7", label: "7. Tamat SMP/Sederajat" },
    { value: "8", label: "8. Tidak Tamat SMA/Sederajat" },
    { value: "9", label: "9. Masih SMA/Sederajat" },
    { value: "10", label: "10. Tamat SMA/Sederajat" },
    { value: "11", label: "11. Masih PT/Akademi" },
    { value: "12", label: "12. Tamat PT/Akademi" },
    { value: "13", label: "13. PAUD" },
  ];
  const [optJnsPendidikan, setOptJnsPendidikan] = useState(
    defaultOptJnsPendidikan
  );
  const [umurnikah, setUmurnikah] = useState(0);

  const defaultOptHubungan = [
    { value: "1", label: "1. Kepala Keluarga" },
    { value: "2", label: "2. Istri" },
    { value: "3", label: "3. Anak" },
    { value: "4", label: "4. Lainnya" },
  ];

  const [optHubungan, setOptHubungan] = useState([
    { value: "1", label: "1. Kepala Keluarga" },
    { value: "2", label: "2. Istri" },
    { value: "3", label: "3. Anak" },
    { value: "4", label: "4. Lainnya" },
  ]);

  const defaultOptKodeIbuKandung = [
    { value: "1", label: "1 - " + keluarga["1"]?.nama_anggotakel },
    { value: "2", label: "2 - " + keluarga["2"]?.nama_anggotakel },
    { value: "0", label: "00 -" },
  ];

  const [optKodeIbuKandung, setOptKodeIbuKandung] = useState([
    { value: "1", label: "1 - " + keluarga["1"]?.nama_anggotakel },
    { value: "2", label: "2 - " + keluarga["2"]?.nama_anggotakel },
    { value: "0", label: "00 -" },
  ]);

  const defaultOptMutasiAnggotaKeluarga = [
    { value: "1", label: "1. Anggota Pindah Keluar" },
    { value: "2", label: "2. Meninggal Dunia" },
    { value: "3", label: "3. Anggota Baru Lahir" },
    { value: "4", label: "4. Anggota Baru Pindah Datang" },
    { value: null, label: "Kosongkan Pilihan" },
  ];

  const [optMutasiAnggotaKeluarga, setOptMutasiAnggotaKeluarga] = useState([
    { value: "1", label: "1. Anggota Pindah Keluar" },
    { value: "2", label: "2. Meninggal Dunia" },
    { value: "3", label: "3. Anggota Baru Lahir" },
    { value: "4", label: "4. Anggota Baru Pindah Datang" },
    { value: null, label: "Kosongkan Pilihan" },
  ]);

  const optDisabilitas = [
    { value: 1, label: "1. Fisik" },
    { value: 2, label: "2. Sensorik" },
    { value: 3, label: "3. Mental" },
    { value: 4, label: "4. Intelektual" },
    { value: 5, label: "5. Tidak" },
  ];
  const [nikError, setNikError] = useState(false);

  const [flagDelete, setFlagDelete] = useState(false);
  const [fullData, setFullData] = useState([]);
  const [tempFullData, setTempFullData] = useState(null);
  const params = useParams();
  const [isRefresh, setIsRefresh] = useState(0);
  const [isFirstStep, setIsFirstStep] = useState(true);
  const [isLastStep, setIsLastStep] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [stepLabel, setStepLabel] = useState([""]);
  const [stepList, setStepList] = useState([
    {
      content: <Keluarga />,
    },
  ]);

  useEffect(() => {
    const fetchData = async () => {
      const kkDoc = await dataBkkbn.local.get(params._id);

      if (kkDoc && Object.keys(kkDoc).length) {
        setTempFullData(kkDoc);
      }
    };

    fetchData();
  }, []);

  // new
  const statuskawin = () => {
    if (id === "2") {
      if (
        keluarga["1"].jenis_kelamin === "1" &&
        keluarga["1"].sts_kawin !== "2" &&
        keluarga["2"].sts_kawin === 2
      ) {
        if (
          keluarga["2"].sts_kawin !== undefined &&
          keluarga["2"].sts_kawin !== "" &&
          keluarga["2"].sts_kawin == "2"
        ) {
          //
          setKeluarga({
            ...keluarga,
            [id]: {
              ...keluarga[id],
              ["sts_kawin"]: "",
            },
          });
        }

        if (
          keluarga["2"].sts_hubungan !== undefined &&
          keluarga["2"].sts_hubungan !== "" &&
          keluarga["2"].sts_hubungan === 2
        ) {
          //
          setKeluarga({
            ...keluarga,
            [id]: {
              ...keluarga[id],
              ["sts_hubungan"]: "",
            },
          });
        }

        if (
          keluarga["2"].usia_kawin !== undefined &&
          keluarga["2"].usia_kawin !== ""
        ) {
          //
          setKeluarga({
            ...keluarga,
            [id]: {
              ...keluarga[id],
              ["usia_kawin"]: "",
            },
          });
        }
      }

      if (
        keluarga["1"].jenis_kelamin === "1" &&
        keluarga["1"].sts_kawin == "2"
      ) {
        if (
          keluarga["2"].sts_kawin === undefined ||
          keluarga["2"].sts_kawin === "" ||
          keluarga["2"].sts_kawin !== "2"
        ) {
          setKeluarga({
            ...keluarga,
            [id]: {
              ...keluarga[id],
              ["sts_kawin"]: "2",
            },
          });
        }

        if (
          keluarga["2"].sts_hubungan === undefined ||
          keluarga["2"].sts_hubungan === "" ||
          keluarga["2"].sts_hubungan !== 2
        ) {
          //
          setKeluarga({
            ...keluarga,
            [id]: {
              ...keluarga[id],
              ["sts_hubungan"]: "2",
            },
          });
        }

        if (
          keluarga["2"].jenis_kelamin === undefined ||
          keluarga["2"].jenis_kelamin === "" ||
          keluarga["2"].jenis_kelamin === "1"
        ) {
          //
          setKeluarga({
            ...keluarga,
            [id]: {
              ...keluarga[id],
              ["jenis_kelamin"]: "2",
            },
          });
        }
      }
    }
  };

  // const qtyKeberadaan = [{ diDalamRumah: 0, diLuarRumah: 0, diLuarNegeri: 0 }]

  const validatePerKepala = (id) => {
    let countError = 0;
    if (!keluarga[id].nama_anggotakel) {
      countError++;
    } else if (!keluarga[id].nama_anggotakel.match(/^[a-zA-Z\.\,\'\ ]+$/)) {
      countError++;
    }
    if (!keluarga[id].nik) {
      countError++;
    } else if (keluarga[id].nik.length !== 16) {
      countError++;
    } else if (keluarga[id].nik === "0000000000000000") {
      countError++;
      enqueueSnackbar("Silakan Sesuaikan NIK yang benar!", {
        variant: "error",
      });
    } else if (keluarga[id].nik === "1111111111111111") {
      countError++;
      enqueueSnackbar("Silakan Sesuaikan NIK yang benar!", {
        variant: "error",
      });
    } else if (keluarga[id].nik === "2222222222222222") {
      countError++;
      enqueueSnackbar("Silakan Sesuaikan NIK yang benar!", {
        variant: "error",
      });
    } else if (keluarga[id].nik === "3333333333333333") {
      countError++;
      enqueueSnackbar("Silakan Sesuaikan NIK yang benar!", {
        variant: "error",
      });
    } else if (keluarga[id].nik === "4444444444444444") {
      countError++;
      enqueueSnackbar("Silakan Sesuaikan NIK yang benar!", {
        variant: "error",
      });
    } else if (keluarga[id].nik === "5555555555555555") {
      countError++;
      enqueueSnackbar("Silakan Sesuaikan NIK yang benar!", {
        variant: "error",
      });
    } else if (keluarga[id].nik === "6666666666666666") {
      countError++;
      enqueueSnackbar("Silakan Sesuaikan NIK yang benar!", {
        variant: "error",
      });
    } else if (keluarga[id].nik === "7777777777777777") {
      countError++;
      enqueueSnackbar("Silakan Sesuaikan NIK yang benar!", {
        variant: "error",
      });
    } else if (keluarga[id].nik === "8888888888888888") {
      countError++;
      enqueueSnackbar("Silakan Sesuaikan NIK yang benar!", {
        variant: "error",
      });
    }

    let cekFind = 0;
    if (Object.keys(keluarga).length > 1) {
      for (let i = 1; i <= Object.keys(keluarga).length; i++) {
        if (
          keluarga["" + i].nik === keluarga[id].nik &&
          keluarga["" + i].no_urutnik !== +id &&
          keluarga["" + i].nik !== "9999999999999999"
        ) {
          cekFind++;
        }
      }
    }
    if (cekFind > 0) {
      countError++;
    }

    if (!keluarga[id].sts_hubungan) {
      countError++;
    } else if (keluarga[id].sts_hubungan === "1") {
      const cekkeluargaKeluarga = Object.values(keluarga).find(
        (kel) => kel.sts_hubungan === "1"
      );
      if (
        cekkeluargaKeluarga &&
        cekkeluargaKeluarga.no_urutnik !== keluarga[id].no_urutnik
      ) {
        countError++;
      }
    } else if (keluarga[id].sts_hubungan === "2") {
      const cekIstri = Object.values(keluarga).find(
        (kel) => kel.sts_hubungan === "2"
      );

      if (cekIstri && cekIstri.no_urutnik !== keluarga[id].no_urutnik) {
        countError++;
      }
    }

    if (!keluarga[id].jenis_kelamin) {
      countError++;
    } else if (
      keluarga[id].jenis_kelamin !== "2" &&
      keluarga[id].sts_hubungan === "2"
    ) {
      countError++;
    }

    // form kode ibu kandung
    if (keluarga[id].sts_hubungan === "3") {
      if (!keluarga[id].kd_ibukandung) {
        countError++;
      } else {
        const cekIstri = Object.values(keluarga).find(
          (kel) => kel.no_urutnik === keluarga[id].kd_ibukandung
        );
        if (
          cekIstri &&
          ["1", "3", "4"].includes(cekIstri.sts_hubungan) &&
          cekIstri.jenis_kelamin === "1"
        ) {
          countError++;
        } else if (
          cekIstri &&
          ["3", "4"].includes(cekIstri.sts_hubungan) &&
          cekIstri.jenis_kelamin === "2"
        ) {
          countError++;
        }
      }
    }

    if (!keluarga[id].sts_akta) {
      countError++;
    }
    if (!keluarga[id].tgl_lahir) {
      countError++;
    } else if (
      keluarga[id].sts_hubungan === "1" &&
      countAge(keluarga[id].tgl_lahir) < 6
    ) {
      countError++;
    }

    if (!keluarga[id].sts_kawin) {
      countError++;
    } else if (
      keluarga[id].sts_hubungan === "2" &&
      keluarga[id].sts_kawin !== "2"
    ) {
      countError++;
    } else if (
      keluarga[id].sts_hubungan === "3" &&
      keluarga[id].sts_kawin === "2"
    ) {
      countError++;
    } else if (
      keluarga[id].sts_hubungan === "4" &&
      keluarga[id].sts_kawin === "2"
    ) {
      countError++;
    } else if (
      keluarga[id].sts_kawin !== "1" &&
      countAge(keluarga[id].tgl_lahir) < 6
    ) {
      countError++;
    }

    if (["2", "3", "4"].includes(keluarga[id].sts_kawin)) {
      //))
      if (!keluarga[id].usia_kawin) {
        countError++;
      } else if (parseInt(keluarga[id].usia_kawin) < 7) {
        countError++;
      } else if (
        keluarga[id].tgl_lahir &&
        parseInt(keluarga[id].usia_kawin) >
          Math.ceil(countAge(keluarga[id].tgl_lahir))
      ) {
        countError++;
      }
    }

    if (!keluarga[id].jns_pendidikan) {
      countError++;
    } else if (
      countAge(keluarga[id].tgl_lahir) <= 7 &&
      ["4", "5", "6", "7", "8", "9", "10"].includes(keluarga[id].jns_pendidikan)
    ) {
      countError++;
    }

    if (!keluarga[id].jns_asuransi) {
      countError++;
    }

    if (!keluarga[id].id_agama) {
      countError++;
    }

    if (!keluarga[id].jenis_pekerjaan) {
      countError++;
    } else if (
      +keluarga[id].jenis_pekerjaan !== 1 &&
      countAge(keluarga[id].tgl_lahir) < 6
    ) {
      countError++;
    }

    if (
      !keluarga[id].sts_pekerjaan &&
      +keluarga[id].jenis_pekerjaan !== 0 &&
      +keluarga[id].jenis_pekerjaan !== 1 &&
      +selectedKeluarga.jenis_pekerjaan !== 10
    ) {
      countError++;
    }

    return countError;
  };

  const handleCheckSegmen = async (event) => {
    const { value } = event.target;
    const targetSegment = parseInt(value);
    let err = 0;
    // console.log(
    //   "Target segment:",
    //   targetSegment,
    //   "Current formIndex:",
    //   formIndex
    // );
    // console.log(true);

    if (value === "0") {
      handleSegmen(event, 0);
      return;
    }
    if (value === "1") {
      handleSegmen(event, 1);
      return;
    }
    if (value === "2") {
      const findErrors = validate();
      const errorValues = Object.values(findErrors);
      if (Object.values(findErrors).length > 0) {
        console.log("findErrors", findErrors);
        setError(findErrors);
        // setError(errorValues);
        return;
      } else {
        console.log(Object.values(keluarga).length);
        for (let [index, anggota] of Object.entries(keluarga)) {
          console.log("anggota", anggota);
          if (
            anggota &&
            anggota.umur >= 17 &&
            anggota.nama_anggotakel &&
            anggota.nik &&
            anggota.jenis_kelamin &&
            anggota.tgl_lahir &&
            anggota.sts_kawin &&
            anggota.usia_kawin &&
            anggota.sts_akta &&
            anggota.sts_hubungan &&
            anggota.id_agama &&
            anggota.jenis_pekerjaan &&
            anggota.bekerja_luar_negeri &&
            anggota.jns_pendidikan &&
            anggota.jns_asuransi &&
            anggota.disabilitas &&
            anggota.disabilitas.length > 0
          ) {
            const findErrors = validate();
            const errorValues = Object.values(findErrors);
            setError(errorValues);
            handleSegmen(event, parseInt(index) + 1);
          } else if (
            anggota &&
            anggota.umur >= 17 &&
            anggota.sts_hubungan !== "3" &&
            anggota.sts_hubungan !== "4" &&
            (!anggota.nama_anggotakel ||
              !anggota.nik ||
              !anggota.jenis_kelamin ||
              !anggota.tgl_lahir ||
              !anggota.sts_kawin ||
              !anggota.usia_kawin ||
              !anggota.sts_akta ||
              !anggota.sts_hubungan ||
              !anggota.id_agama ||
              !anggota.jenis_pekerjaan ||
              !anggota.bekerja_luar_negeri ||
              !anggota.jns_pendidikan ||
              !anggota.jns_asuransi ||
              !anggota.disabilitas ||
              !anggota.disabilitas.length > 0)
          ) {
            console.log("ada form yang kosong");
            const findErrors = validate();
            const errorValues = Object.values(findErrors);
            setError(errorValues);
            break;
          } else if (
            anggota &&
            anggota.umur < 17 &&
            anggota.nama_anggotakel &&
            anggota.nik &&
            anggota.jenis_kelamin &&
            anggota.tgl_lahir &&
            anggota.sts_kawin &&
            anggota.sts_akta &&
            anggota.sts_hubungan &&
            anggota.id_agama &&
            anggota.jenis_pekerjaan &&
            anggota.jns_pendidikan &&
            anggota.jns_asuransi &&
            anggota.disabilitas &&
            anggota.disabilitas.length > 0
          ) {
            handleSegmen(event, parseInt(index) + 1);
          }
        }
      }

      // if (errorValues.length > 0 && errorValues.some((err) => err !== "")) {
      //   setError(findErrors);
      //   enqueueSnackbar("Lengkapi Form Keluarga", { variant: "warning" });
      //   return;
      // }
      // handleSegmen(event, 1);
      // return;
    }

    for (let i = 1; i <= Object.keys(keluarga).length; i++) {
      let cek = validatePerKepala(i);
      err = err + cek;
    }

    const findErrors = validate();
    setError(findErrors);

    const errorValues = Object.values(findErrors);

    // console.log("error value", errorValues);

    const x = parseInt(wilayah.jumlah_keluarga);

    let hasErrors = false;

    // for (const memberId in keluarga) {
    //   if (keluarga[memberId] && errorValues.length > 0) {
    //     hasErrors = true;
    //     break;
    //   }
    // }

    // if (errorValues.length === 0) {
    //   handleNext();
    // } else if (hasErrors) {
    //   enqueueSnackbar("Silakan lengkapi Form Data Kependudukan", {
    //     variant: "warning",
    //   });
    //   setError(findErrors);
    // } else {
    //   handleSegmen(event, x);
    // }

    if (errorValues.length > 0) {
      // enqueueSnackbar("Silakan lengkapi Form Data Kependudukan", {
      //   variant: "error",
      // });
      setError(findErrors);
    } else {
      const { value } = event.target;
      const x = parseInt(wilayah.jumlah_keluarga);
      //
      if (value) {
        let val = parseInt(value);
        //
        if (x > 1) {
          val > 1 ? (val = val + x - 1) : (val = val);
        }
        let segment_pus = wilayah.pertanyaan_pus || "";

        if ((x === 1 && val === 2) || (segment_pus !== 1 && value === 4)) {
          let message;
          if (val === 2) {
            message = `Data KB tidak Tersedia`;
          } else {
            message = `Data Stunting tidak Tersedia`;
          }

          enqueueSnackbar(message, { variant: "error" });
        } else {
          //
          if (value === 3 && isSomethingChange === true) {
            let message = `Silakan Lengkapi Data KB Terlebih Dahulu`;
            enqueueSnackbar(message, { variant: "warning" });
          } else {
            if (value === "3") {
              if (!kb || Object.keys(kb).length === 0) {
                handleSegmen(event, val);
                enqueueSnackbar("Lengkapi data terlebih dahulu!", {
                  variant: "warning",
                });
                setError(findErrors);
                return;
              }
            }
            // if (x > 1) {
            //   let anggotaBelumLengkap = [];
            //   for (let i = 1; i <= x; i++) {
            //     if (!keluarga[i] || Object.keys(keluarga[i]).length === 0) {
            //       anggotaBelumLengkap.push(i);
            //       continue;
            //     }
            //     const errAnggota = validatePerKepala(i);
            //     if (errAnggota > 0) {
            //       anggotaBelumLengkap.push(i);
            //     }
            //   }
            //   console.log("Anggota belum lengkap:", anggotaBelumLengkap);

            //   if (anggotaBelumLengkap.length > 0) {
            //     enqueueSnackbar(
            //       `Data anggota keluarga No. ${anggotaBelumLengkap.join(
            //         ", "
            //       )} belum lengkap`,
            //       { variant: "error" }
            //     );
            //     return;
            //   }
            // }
            // handleSegmen(event, val);
          }
        }
      }
    }
    // }
  };

  const parseDate = (dateString) => {
    if (!dateString) {
      // Handle the case where dateString is null or undefined
      return null;
    }
    const [day, month, year] = dateString.split("-");
    return new Date(year, month - 1, day);
  };

  // useEffect(() => {
  //   console.log("State keluarga telah diperbarui:", keluarga);
  // }, [keluarga]);

  useEffect(() => {
    if (
      keluarga["1"] &&
      keluarga["1"].jenis_kelamin === "1" &&
      keluarga["1"].sts_kawin === "2" &&
      keluarga["2"] &&
      (keluarga["2"].jenis_kelamin !== "2" ||
        keluarga["2"].sts_hubungan !== "2" ||
        keluarga["2"].sts_kawin !== "2")
    ) {
      setKeluarga((prevState) => ({
        ...prevState,
        2: {
          ...prevState["2"],
          jenis_kelamin: "2",
          sts_hubungan: "2",
          sts_kawin: "2",
        },
      }));
    } else if (
      keluarga["1"] &&
      keluarga["1"].jenis_kelamin === "1" &&
      keluarga["1"].sts_kawin === "3" &&
      keluarga["2"] &&
      (keluarga["2"].jenis_kelamin !== "2" ||
        keluarga["2"].sts_hubungan !== "2" ||
        keluarga["2"].sts_kawin !== "3")
    ) {
      setKeluarga((prevState) => ({
        ...prevState,
        2: {
          ...prevState["2"],
          jenis_kelamin: "2",
          sts_hubungan: "2",
          sts_kawin: "3",
        },
      }));
    }
  }, [keluarga["1"]?.sts_kawin]);

  const handleChange = (e) => {
    const { type, name, value } = e.target;

    if (type === "number") {
      if (parseInt(value) < 0) return false;

      if (name === "nik") {
        if (value.length > 16) {
          return false;
        }
      }
    }

    if (name === "jenis_pekerjaan" && +value === 11) {
      setOptStsPekerjaan([
        { value: "1", label: "1. Berusaha Sendiri" },
        { value: "5", label: "5. Pekerja Bebas" },
      ]);
    } else if (
      name === "jenis_pekerjaan" &&
      (+value === 7 || +value === 8 || +value === 9)
    ) {
      setOptStsPekerjaan([
        { value: "3", label: "3. Berusaha dibantu Buruh Tetap/Buruh Dibayar" },
        { value: "4", label: "4. Buruh/Karyawan/Pegawai" },
      ]);
    } else {
      setOptStsPekerjaan([
        { value: "1", label: "1. Berusaha Sendiri" },
        {
          value: "2",
          label: "2. Berusaha dibantu Buruh Tidak Tetap/Buruh Tidak Dibayar",
        },
        { value: "3", label: "3. Berusaha dibantu Buruh Tetap/Buruh Dibayar" },
        { value: "4", label: "4. Buruh/Karyawan/Pegawai" },
        { value: "5", label: "5. Pekerja Bebas" },
        { value: "6", label: "6. Pekerja Keluarga/Tidak Dibayar" },
      ]);
    }

    if (name === "jenis_pekerjaan" && +value !== 5 && +value !== 6) {
      setKeluarga({
        ...keluarga,
        [id]: {
          ...keluarga[id],
          [name]: value,
          ["sts_pekerjaan"]: "",
        },
      });
    } else if (name === "jenis_pekerjaan" && (+value === 5 || +value === 6)) {
      setKeluarga({
        ...keluarga,
        [id]: {
          ...keluarga[id],
          [name]: value,
          ["sts_pekerjaan"]: "4",
        },
      });
    } else if (name === "disabilitas") {
      let updatedValue = [...value];

      // Check if "5. Tidak" is selected
      if (updatedValue.includes(5)) {
        updatedValue = [5];
      }

      if (value.length > 1 && value[0] === 5) {
        // Jika hanya ada "5", hapus semua nilai
        updatedValue = updatedValue.filter((v) => v !== 5);
      }

      let filteredValue;
      if (updatedValue) {
        filteredValue = updatedValue.filter((value) => value !== "");
      }

      setKeluarga({
        ...keluarga,
        [id]: {
          ...keluarga[id],
          [name]: filteredValue,
          mengurus_diri: filteredValue.includes(5)
            ? ""
            : keluarga[id].mengurus_diri,
        },
      });
    } else if (name === "mengurus_diri") {
      setKeluarga({
        ...keluarga,
        [id]: {
          ...keluarga[id],
          [name]: value,
        },
      });
    } else if (name === "jenis_pekerjaan" && (+value === 5 || +value === 6)) {
      setKeluarga({
        ...keluarga,
        [id]: {
          ...keluarga[id],
          [name]: value,
          ["sts_pekerjaan"]: "4",
        },
      });
    } else {
      setKeluarga({
        ...keluarga,
        [id]: {
          ...keluarga[id],
          [name]: value,
        },
      });
    }

    if (
      name === "sts_kawin" &&
      value === "1" &&
      (selectedKeluarga.sts_hubungan === "3" ||
        selectedKeluarga.sts_hubungan === "4") &&
      countAge(selectedKeluarga.tgl_lahir) >= 5 &&
      countAge(selectedKeluarga.tgl_lahir) <= 18
    ) {
      setOptJnsPendidikan(
        defaultOptJnsPendidikan.filter(
          (el) => el.value !== "4" && el.value !== "7"
        )
      );
    } else if (
      name === "tgl_lahir" &&
      selectedKeluarga.sts_kawin === "1" &&
      (selectedKeluarga.sts_hubungan === "3" ||
        selectedKeluarga.sts_hubungan === "4") &&
      countAge(value) >= 5 &&
      countAge(value) <= 18
    ) {
      setOptJnsPendidikan(
        defaultOptJnsPendidikan.filter(
          (el) => el.value !== "4" && el.value !== "7"
        )
      );
    } else if (
      selectedKeluarga.sts_kawin === "1" &&
      (selectedKeluarga.sts_hubungan === "3" ||
        selectedKeluarga.sts_hubungan === "4") &&
      countAge(selectedKeluarga.tgl_lahir) >= 5 &&
      countAge(selectedKeluarga.tgl_lahir) <= 18
    ) {
      setOptJnsPendidikan(
        defaultOptJnsPendidikan.filter(
          (el) => el.value !== "4" && el.value !== "7"
        )
      );
    } else {
      setOptJnsPendidikan(defaultOptJnsPendidikan);
    }

    if (name === "tgl_lahir" && countAge(value) <= 18) {
      setKeluarga({
        ...keluarga,
        [id]: {
          ...keluarga[id],
          [name]: value,
          ["bekerja_luar_negeri"]: "4",
        },
      });
    }

    if (name === "jenis_pekerjaan" && ["1", "5", "6", "10"].includes(value)) {
      setOptKerjaLuarNegeri(
        defaultOptKerjaLuarNegeri.filter((el) => el.value !== "2")
      );
    } else {
      setOptKerjaLuarNegeri(defaultOptKerjaLuarNegeri);
    }

    setError({
      ...error,
      [name]: "",
    });

    setSomethingChange(true);
  };

  const handleChangeUppercase = (e) => {
    const { type, name, value } = e.target;

    if (
      keluarga["1"].jenis_kelamin === "1" &&
      keluarga["1"].sts_kawin === "2" &&
      id === "2"
    ) {
      setKeluarga({
        ...keluarga,
        [id]: {
          ...keluarga[id],
          ["jenis_kelamin"]: "2",
          ["sts_kawin"]: "2",
          ["sts_hubungan"]: "2",
        },
      });
    }

    if (
      keluarga["1"].jenis_kelamin === "1" &&
      keluarga["1"].sts_kawin === "3" &&
      id === "2"
    ) {
      setKeluarga({
        ...keluarga,
        [id]: {
          ...keluarga[id],
          ["jenis_kelamin"]: "2",
          ["sts_kawin"]: "3",
          ["sts_hubungan"]: "2",
        },
      });
    }

    setKeluarga((prevState) => ({
      ...prevState,
      [id]: {
        ...prevState[id],
        [name]: value.replace(/\d/g, "").toUpperCase(),
      },
    }));

    setError({
      ...error,
      [name]: "",
    });
    setSomethingChange(true);
  };

  const handleUsiaKawin = (e) => {
    const { type, name, value } = e.target;
    setKeluarga({
      ...keluarga,
      [id]: {
        ...keluarga[id],
        [name]: 0,
      },
    });

    setError({
      ...error,
      [name]: "",
    });
    setSomethingChange(true);
  };

  const handleChangeStsAkta = (e) => {
    const { type, name, value } = e.target;
    if (type === "number") {
      if (parseInt(value) < 0) return false;
      if (name === "nik" && value.length > 16) {
        return false;
      }
    }

    // set object Keluarga sts_hubungan == kepala keluarga
    // kondisi ini dijalanlan saat form keluarga yang pertama atau index 0

    if (id === "1") {
      setKeluarga({
        ...keluarga,
        [id]: {
          ...keluarga[id],
          ["sts_hubungan"]: "1",
        },
      });
    }
    if (
      keluarga["1"].jenis_kelamin === "1" &&
      keluarga["1"].sts_kawin === "2" &&
      id === "2"
    ) {
      setKeluarga({
        ...keluarga,
        [id]: {
          ...keluarga[id],
          ["sts_hubungan"]: "2",
        },
      });
    }

    setKeluarga((prevState) => ({
      ...prevState,
      [id]: {
        ...prevState[id],
        [name]: value,
      },
    }));

    setError({
      ...error,
      [name]: "",
    });
    setSomethingChange(true);
  };

  const handleChangeJnsAsuransi = (e) => {
    const { type, name, value } = e.target;
    if (type === "number") {
      if (parseInt(value) < 0) return false;
      if (name === "nik" && value.length > 16) {
        return false;
      }
    }

    // Jika hanya 1 orang langsung default keberadaan di dalam rumah
    if (id === "1" && wilayah.jumlah_keluarga === "1") {
      setKeluarga({
        ...keluarga,
        [id]: {
          ...keluarga[id],
          // ["keberadaan"]: "1"
        },
      });
    }

    setKeluarga((prevState) => ({
      ...prevState,
      [id]: {
        ...prevState[id],
        [name]: value,
      },
    }));

    setError({
      ...error,
      [name]: "",
    });
    setSomethingChange(true);
  };

  const handleChangeMutasiAnggotaKeluarga = (e) => {
    const { type, name, value } = e.target;

    setKeluarga((prevState) => ({
      ...prevState,
      [id]: {
        ...prevState[id],
        [name]: value,
      },
    }));

    setError({
      ...error,
      [name]: "",
    });
    setSomethingChange(true);
  };

  const handleChangeHubungan = (e) => {
    const { type, name, value } = e.target;
    if (type === "number") {
      if (parseInt(value) < 0) return false;
      if (name === "nik" && value.length > 16) {
        return false;
      }
    }

    // kondisi jika memilih sts_hubungan anak memiliki ibu yg berstatus cerai hidup atau cerai mati
    if (
      keluarga["1"].sts_hubungan === "1" &&
      (keluarga["1"].sts_kawin === "3" || keluarga["1"].sts_kawin === "4") &&
      keluarga["1"].jenis_kelamin === "2"
    ) {
      setKeluarga({
        ...keluarga,
        [id]: {
          ...keluarga[id],
          ["kd_ibukandung"]: "1",
        },
      });
    }

    // kondisi jika memilih sts_hubungan anak memiliki ibu
    if (
      keluarga["1"].sts_hubungan === "1" &&
      (keluarga["1"].sts_kawin === "2" || keluarga["1"].sts_kawin === "3") &&
      keluarga["1"].jenis_kelamin === "1"
    ) {
      setKeluarga({
        ...keluarga,
        [id]: {
          ...keluarga[id],
          ["kd_ibukandung"]: "2",
        },
      });
    }

    // kondisi jika memilih sts_hubungan anak dan tidak memiliki ibu maka value default 0
    if (
      keluarga["1"].sts_hubungan === "1" &&
      (keluarga["1"].sts_kawin === "4" ||
        keluarga["1"].sts_kawin === "5" ||
        keluarga["1"].sts_kawin === "6") &&
      keluarga["1"].jenis_kelamin === "1"
    ) {
      setKeluarga({
        ...keluarga,
        [id]: {
          ...keluarga[id],
          ["kd_ibukandung"]: "0",
        },
      });
    }

    //kondisi belum kawin, sts_hubungan 3/4, umur antara 5-18, maka opsi pendidikan 4&7 hihlang
    if (
      selectedKeluarga.sts_kawin === "1" &&
      (value === "3" || value === "4") &&
      countAge(selectedKeluarga.tgl_lahir) >= 5 &&
      countAge(selectedKeluarga.tgl_lahir) <= 18
    ) {
      setOptJnsPendidikan(
        defaultOptJnsPendidikan.filter(
          (el) => el.value !== "4" && el.value !== "7"
        )
      );
    } else {
      setOptJnsPendidikan(defaultOptJnsPendidikan);
    }

    setKeluarga((prevState) => ({
      ...prevState,
      [id]: {
        ...prevState[id],
        [name]: value,
      },
    }));

    setError({
      ...error,
      [name]: "",
    });
    setSomethingChange(true);
  };

  const handleDateChange = (name) => (newDate) => {
    const value = formatDate(newDate, formatString);
    handleChange({ target: { value, name } });
    setTimeout(() => {
      const keluargaChangedEvent = new CustomEvent("keluargaDataChanged", {
        detail: { keluarga: keluarga },
      });
      document.dispatchEvent(keluargaChangedEvent);
      console.log("Dispatched keluargaDataChanged event after date change");
    }, 100);

    setSomethingChange(true);
  };

  const selectedKeluarga = keluarga[id];

  useEffect(() => {
    if (
      selectedKeluarga &&
      selectedKeluarga.kd_ibukandung &&
      selectedKeluarga.sts_hubungan
    ) {
      const currentKdIbu = parseInt(selectedKeluarga.kd_ibukandung);
      const currentHubungan = selectedKeluarga.sts_hubungan;
      if ([1, 2].includes(currentKdIbu) && currentHubungan !== "3") {
        console.log("reset kode ibu karena hubungan bukan anak");

        setKeluarga((prevState) => ({
          ...prevState,
          [id]: {
            ...prevState[id],
            kd_ibukandung: "0",
          },
        }));

        setOptKodeIbuKandung(
          defaultOptKodeIbuKandung.filter((el) => el.value === "0")
        );

        setError((prevError) => ({
          ...prevError,
          kd_ibukandung: "",
        }));

        setSomethingChange(true);
      }
    }
  }, [selectedKeluarga.kd_ibukandung, selectedKeluarga.sts_hubungan, id, mode]);

  if (typeof selectedKeluarga.disabilitas === "string") {
    selectedKeluarga.disabilitas = [parseInt(selectedKeluarga.disabilitas)];
  }

  const validasired = () => {
    setNikError(false);
    const birthDate = parseDate(selectedKeluarga?.tgl_lahir);

    if (!birthDate || isNaN(birthDate)) {
      return;
    }

    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();

    if (
      monthDifference < 0 ||
      (monthDifference === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    if (age > 17 && selectedKeluarga.nik === "9999999999999999") {
      setNikError(true);
    } else {
      setNikError(false);
    }
  };

  useEffect(() => {
    validasired();
  }, [keluarga]);

  useEffect(() => {
    validate();
    if (parseInt(wilayah.jumlah_keluarga) !== 1) {
      setError({});
    }
    validasired();
  }, [selectedKeluarga]);

  useEffect(() => {
    if (Object.keys(keluarga).length) {
      // === Option Hubungan Dengan Kepala Keluarga === //
      if (selectedKeluarga) {
        /* default halaman pertama kepala keluarga */
        if (id === "1") {
          setOptHubungan(defaultOptHubungan.filter((el) => el.value === "1"));
        }

        /* jika halaman pertamanya seorang laki2 dan berstatus kawin maka default halaman ke duanya harus istri */
        if (
          keluarga["1"].jenis_kelamin === "1" &&
          (keluarga["1"].sts_kawin === "2" ||
            keluarga["1"].sts_kawin === "3") &&
          id === "2"
        ) {
          setOptHubungan(defaultOptHubungan.filter((el) => el.value === "2"));
        }

        /* jika halaman keduanya default istri maka halaman seterusnya harus anak dan lainnya */
        if (
          keluarga["1"].jenis_kelamin === "1" &&
          (keluarga["1"].sts_kawin === "2" ||
            keluarga["1"].sts_kawin === "3") &&
          id > 2
        ) {
          setOptHubungan(
            defaultOptHubungan.filter(
              (el) => el.value === "3" || el.value === "4"
            )
          );
        }

        /* jika halaman pertama seorang perempuan dan berstatus kawin halaman ke dua dan seterusnya harus anak dan lainnya */
        if (
          keluarga["1"].jenis_kelamin === "2" &&
          (keluarga["1"].sts_kawin === "2" ||
            keluarga["1"].sts_kawin === "3") &&
          id >= 2
        ) {
          setOptHubungan(
            defaultOptHubungan.filter(
              (el) => el.value === "3" || el.value === "4"
            )
          );
        }

        /* jika halaman pertamanya cerai maka yg tampil di halaman ke dua dan seterusnya harus anak dan lainnya */
        if (
          (keluarga["1"].sts_kawin === "4" ||
            keluarga["1"].sts_kawin === "5" ||
            keluarga["1"].sts_kawin === "6") &&
          id >= 2
        ) {
          setOptHubungan(
            defaultOptHubungan.filter(
              (el) => el.value === "3" || el.value === "4"
            )
          );
        }

        /* jika halaman pertamanya belum kawin maka yg tampil di halaman ke dua dan seterusnya lainnya */
        if (keluarga["1"].sts_kawin === "1" && id >= 2) {
          setOptHubungan(
            defaultOptHubungan.filter(
              (el) => el.value === "3" || el.value === "4"
            )
          );
        }

        /* jika halaman pertamanya belum kawin atau sudah tidak memiliki orang tua maka yg tampil di halaman ke dua dan seterusnya lainnya */
        if (
          keluarga["1"].sts_kawin === "1" &&
          keluarga["1"].sts_hubungan === "1" &&
          id >= 2
        ) {
          setOptHubungan(defaultOptHubungan.filter((el) => el.value === "4"));
        }
      }

      // === Option Kode Ibu Kandung === //
      if (selectedKeluarga) {
        Object.values(keluarga).map((kel) => {
          if (Object.keys(keluarga).length > 1) {
            if (
              kel.sts_hubungan === "1" &&
              (kel.sts_kawin === "2" || kel.sts_kawin === "3") &&
              kel.jenis_kelamin === "1"
            ) {
              setOptKodeIbuKandung(
                defaultOptKodeIbuKandung.filter(
                  (el) => el.value === "2" || el.value === "0"
                )
              );
            }

            if (
              kel.sts_hubungan === "1" &&
              !(kel.sts_kawin === "2" || kel.sts_kawin === "3") &&
              kel.jenis_kelamin === "2"
            ) {
              setOptKodeIbuKandung(
                defaultOptKodeIbuKandung.filter(
                  (el) => el.value === "1" || el.value === "0"
                )
              );
            }

            if (
              kel.sts_hubungan === "1" &&
              (kel.sts_kawin === "4" ||
                kel.sts_kawin === "5" ||
                kel.sts_kawin === "6") &&
              kel.jenis_kelamin === "1"
            ) {
              setOptKodeIbuKandung(
                defaultOptKodeIbuKandung.filter((el) => el.value === "0")
              );
            }

            if (
              kel.sts_hubungan === "1" &&
              (kel.sts_kawin === "4" ||
                kel.sts_kawin === "5" ||
                kel.sts_kawin === "6") &&
              kel.jenis_kelamin === "2"
            ) {
              setOptKodeIbuKandung(
                defaultOptKodeIbuKandung.filter(
                  (el) => el.value === "1" || el.value === "0"
                )
              );
            }

            if (
              kel.sts_hubungan === "1" &&
              kel.sts_kawin === "1" &&
              (kel.jenis_kelamin === "1" || kel.jenis_kelamin === "2")
            ) {
              setOptKodeIbuKandung(
                defaultOptKodeIbuKandung.filter((el) => el.value === "0")
              );
            }

            // if (kel.sts_hubungan === "3" && (kel.sts_kawin === "3" && kel.sts_kawin === "4") && kel.jenis_kelamin === "2"){
            //     setOptKodeIbuKandung(
            //         defaultOptKodeIbuKandung.filter((el) => el.value === "1" || el.value === "0")
            //     )
            // }
          }
        });
      }

      // === Option Status Pekerjaan === //
      if (selectedKeluarga) {
        if (+selectedKeluarga.jenis_pekerjaan === 11) {
          setOptStsPekerjaan([
            { value: "1", label: "1. Berusaha Sendiri" },
            { value: "5", label: "5. Pekerja Bebas" },
          ]);
        } else if (
          +selectedKeluarga.jenis_pekerjaan === 7 ||
          +selectedKeluarga.jenis_pekerjaan === 8 ||
          +selectedKeluarga.jenis_pekerjaan === 9
        ) {
          setOptStsPekerjaan([
            {
              value: "3",
              label: "3. Berusaha dibantu Buruh Tetap/Buruh Dibayar",
            },
            { value: "4", label: "4. Buruh/Karyawan/Pegawai" },
          ]);
        } else {
          setOptStsPekerjaan([
            { value: "1", label: "1. Berusaha Sendiri" },
            {
              value: "2",
              label:
                "2. Berusaha dibantu Buruh Tidak Tetap/Buruh Tidak Dibayar",
            },
            {
              value: "3",
              label: "3. Berusaha dibantu Buruh Tetap/Buruh Dibayar",
            },
            { value: "4", label: "4. Buruh/Karyawan/Pegawai" },
            { value: "5", label: "5. Pekerja Bebas" },
            { value: "6", label: "6. Pekerja Keluarga/Tidak Dibayar" },
          ]);
        }
      }

      // === Option Mutasi Anggota Keluarga === //
      if (selectedKeluarga) {
        if (
          keluarga[id].sts_hubungan === "3" ||
          keluarga[id].sts_hubungan === "4"
        ) {
          if (keluarga[id].flagNew === true) {
            setOptMutasiAnggotaKeluarga(
              defaultOptMutasiAnggotaKeluarga.filter(
                (el) =>
                  el.value === "3" || el.value === "4" || el.value === null
              )
            );
          } else {
            setOptMutasiAnggotaKeluarga(
              defaultOptMutasiAnggotaKeluarga.filter((el) => el.value !== "3")
            );
          }
        } else {
          if (keluarga[id].flagNew === true) {
            setOptMutasiAnggotaKeluarga(
              defaultOptMutasiAnggotaKeluarga.filter(
                (el) =>
                  el.value === "3" || el.value === "4" || el.value === null
              )
            );
          } else {
            setOptMutasiAnggotaKeluarga(
              defaultOptMutasiAnggotaKeluarga.filter((el) => el.value !== "3")
            );
          }
        }
      }

      // === Option Status Perkawinan === //
      if (selectedKeluarga) {
        if (parseInt(wilayah.jmlKeluarga) === 1) {
        }
      }
    }

    if (selectedKeluarga.sts_kawin === "1") {
      selectedKeluarga.usia_kawin = null;
      setUmurnikah(null);
    } else {
      const umur_nikah = countAge(selectedKeluarga.tgl_lahir);
      setUmurnikah(umur_nikah);
    }
  }, [selectedKeluarga]);

  //
  //const lastKeluarga = ('0' + wilayah.jumlah_keluarga).slice(-2);
  const lastKeluarga = wilayah.jumlah_keluarga;

  const validate = () => {
    let newError = {};
    if (!selectedKeluarga.nama_anggotakel) {
      newError.nama_anggotakel = "Nama Lengkap wajib diisi";
    } else if (!selectedKeluarga.nama_anggotakel.match(/^[a-zA-Z\.\,\'\ ]+$/)) {
      newError.nama_anggotakel = "Nama tidak boleh mengandung Angka & Symbol";
    }
    // else if (selectedKeluarga.nama_anggotakel && selectedKeluarga.nama_anggotakel.length > 3) {
    //     newError.nama_anggotakel = "Nama Lengkap tidak boleh lebih dari 20 digit";
    // }

    if (!selectedKeluarga.nik) {
      newError.nik = "NIK wajib diisi";
    } else if (selectedKeluarga.nik.length !== 16) {
      newError.nik = "NIK harus 16 digit";
    } else if (selectedKeluarga.nik === "0000000000000000") {
      newError.nik = "NIK tidak boleh 0 16x";
    } else if (selectedKeluarga.nik === "1111111111111111") {
      newError.nik = "NIK tidak boleh 1 16x";
    } else if (selectedKeluarga.nik === "2222222222222222") {
      newError.nik = "NIK tidak boleh 2 16x";
    } else if (selectedKeluarga.nik === "3333333333333333") {
      newError.nik = "NIK tidak boleh 3 16x";
    } else if (selectedKeluarga.nik === "4444444444444444") {
      newError.nik = "NIK tidak boleh 4 16x";
    } else if (selectedKeluarga.nik === "5555555555555555") {
      newError.nik = "NIK tidak boleh 5 16x";
    } else if (selectedKeluarga.nik === "6666666666666666") {
      newError.nik = "NIK tidak boleh 6 16x";
    } else if (selectedKeluarga.nik === "7777777777777777") {
      newError.nik = "NIK tidak boleh 7 16x";
    } else if (selectedKeluarga.nik === "8888888888888888") {
      newError.nik = "NIK tidak boleh 8 16x";
    }

    let cekFind = 0;
    if (Object.keys(keluarga).length > 1) {
      for (let i = 1; i <= Object.keys(keluarga).length; i++) {
        if (
          keluarga["" + i].nik === selectedKeluarga.nik &&
          keluarga["" + i].no_urutnik !== +id &&
          keluarga["" + i].nik !== "9999999999999999"
        ) {
          cekFind++;
        }
      }
    }

    if (cekFind > 0) {
      newError.nik = "NIK tidak boleh sama";
    }

    if (!selectedKeluarga.sts_hubungan) {
      newError.sts_hubungan = "Hubungan dengan Kepala Keluarga wajib diisi";
    } else if (selectedKeluarga.sts_hubungan === "1") {
      const cekKepalaKeluarga = Object.values(keluarga).find(
        (kel) => kel.sts_hubungan === "1"
      );
      if (
        cekKepalaKeluarga &&
        cekKepalaKeluarga.no_urutnik !== selectedKeluarga.no_urutnik
      ) {
        newError.sts_hubungan = "Hanya boleh ada satu Kepala Keluarga";
      }
    } else if (selectedKeluarga.sts_hubungan === "2") {
      const cekIstri = Object.values(keluarga).find(
        (kel) => kel.sts_hubungan === "2"
      );

      if (cekIstri && cekIstri.no_urutnik !== selectedKeluarga.no_urutnik) {
        newError.sts_hubungan = "Hanya boleh ada satu Istri";
      }
    }

    if (!selectedKeluarga.jenis_kelamin) {
      newError.jenis_kelamin = "Jenis Kelamin wajib diisi";
    } else if (
      selectedKeluarga.jenis_kelamin !== "2" &&
      selectedKeluarga.sts_hubungan === "2"
    ) {
      newError.jenis_kelamin = "Istri harus berjenis kelamin perempuan";
    }

    // form kode ibu kandung
    if (selectedKeluarga.sts_hubungan === "3") {
      if (
        !selectedKeluarga.kd_ibukandung &&
        keluarga[1].jenis_kelamin !== "1"
      ) {
        newError.kd_ibukandung = "Kode Ibu Kandung wajib diisi";
      } else {
        const cekIstri = Object.values(keluarga).find(
          (kel) => kel.no_urutnik === selectedKeluarga.kd_ibukandung
        );
        // if (cekIstri && cekIstri.sts_hubungan !== "2") {
        //     newError.kd_ibukandung = "Kode Ibu Kandung harus istri dari kepala keluarga atau wanita dengan status kepala keluarga";
        // }
        if (
          cekIstri &&
          ["1", "3", "4"].includes(cekIstri.sts_hubungan) &&
          cekIstri.jenis_kelamin === "1"
        ) {
          newError.kd_ibukandung =
            "Kode Ibu Kandung harus istri dari kepala keluarga";
        } else if (
          cekIstri &&
          ["3", "4"].includes(cekIstri.sts_hubungan) &&
          cekIstri.jenis_kelamin === "2"
        ) {
          newError.kd_ibukandung =
            "Kode Ibu Kandung harus istri dari kepala keluarga";
        }
      }
    }

    if (!selectedKeluarga.sts_akta) {
      newError.sts_akta = "Status Akta Lahir wajib diisi";
    }

    if (!selectedKeluarga.tgl_lahir) {
      newError.tgl_lahir = "Tanggal Lahir wajib diisi";
    } else if (
      selectedKeluarga.sts_hubungan === "1" &&
      countAge(selectedKeluarga.tgl_lahir) < 6
    ) {
      newError.tgl_lahir = "Umur Kepala Keluarga tidak boleh < 5 Tahun";
    }
    if (
      !selectedKeluarga.sts_kawin ||
      selectedKeluarga.sts_kawin === "" ||
      selectedKeluarga.sts_kawin === null ||
      selectedKeluarga.sts_kawin === undefined
    ) {
      newError.sts_kawin = "Status Perkawinan wajib diisi";
    } else if (
      (mode === "edit" && !selectedKeluarga.sts_kawin) ||
      (mode === "edit" &&
        id === "1" &&
        selectedKeluarga.sts_kawin === "2" &&
        selectedKeluarga.jenis_kelamin === "2" &&
        selectedKeluarga.sts_hubungan === "1")
    ) {
      newError.sts_kawin =
        "Istri sebagai Kepala Keluarga tidak boleh berstatus Kawin";
    } else if (
      selectedKeluarga.sts_hubungan === "2" &&
      !(
        selectedKeluarga.sts_kawin === "2" || selectedKeluarga.sts_kawin === "3"
      )
    ) {
      newError.sts_kawin = "Istri harus berstatus Kawin";
    } else if (
      selectedKeluarga.sts_hubungan === "3" &&
      (selectedKeluarga.sts_kawin === "2" || selectedKeluarga.sts_kawin === "3")
    ) {
      newError.sts_kawin = "Anak tidak boleh berstatus Kawin";
    } else if (
      selectedKeluarga.sts_hubungan === "4" &&
      (selectedKeluarga.sts_kawin === "2" || selectedKeluarga.sts_kawin === "3")
    ) {
      newError.sts_kawin =
        "Anggota keluarga lainnya tidak boleh berstatus Kawin";
    } else if (
      selectedKeluarga.sts_kawin !== "1" &&
      countAge(selectedKeluarga.tgl_lahir) < 6
    ) {
      newError.sts_kawin =
        "Status Kawin, Cerai Hidup/Mati tidak boleh berusia < 5 Tahun";
    }

    if (["2", "3", "4", "5", "6"].includes(selectedKeluarga.sts_kawin)) {
      //))
      if (!selectedKeluarga.usia_kawin) {
        newError.usia_kawin = "Usia Kawin Pertama wajib diisi";
      } else if (parseInt(selectedKeluarga.usia_kawin) < 7) {
        newError.usia_kawin = "Usia Kawin Pertama tidak boleh diisi < 7 tahun";
      } else if (
        selectedKeluarga.tgl_lahir &&
        parseInt(selectedKeluarga.usia_kawin) >
          Math.ceil(countAge(selectedKeluarga.tgl_lahir))
      ) {
        newError.usia_kawin =
          "Usia Kawin Pertama tidak boleh lebih besar dari umur";
      }
    }

    if (!selectedKeluarga.jns_pendidikan) {
      newError.jns_pendidikan = "Pendidikan wajib diisi";
    } else if (
      countAge(selectedKeluarga.tgl_lahir) <= 7 &&
      ["4", "5", "6", "7", "8", "9", "10", "11", "12"].includes(
        selectedKeluarga.jns_pendidikan
      )
    ) {
      // newError.jns_pendidikan = "usia harus > 7 tahun";
      newError.jns_pendidikan =
        "Individu berusia <= 7 tahun hanya boleh mengisi kode 1 atau 2 atau 3 atau 13";
    } else if (
      countAge(selectedKeluarga.tgl_lahir) > 7 &&
      ["13"].includes(selectedKeluarga.jns_pendidikan) &&
      selectedKeluarga.sts_hubungan !== "3" &&
      selectedKeluarga.sts_hubungan !== "4"
    ) {
      newError.jns_pendidikan =
        "Pilihan pendidikan 13. PAUD hanya boleh untuk status hubungan anak/lainnya dengan usia <= 6 tahun";
    }

    if (!selectedKeluarga.jns_asuransi) {
      newError.jns_asuransi = "Kepesertaan JKN wajib diisi";
    }

    // if (!selectedKeluarga.mutasi_anggota_keluarga) {
    //     newError.mutasi_anggota_keluarga = "Mutasi anggota keluarga wajib diisi";
    // }

    if (!selectedKeluarga.id_agama) {
      newError.id_agama = "Agama wajib diisi";
    }

    if (!selectedKeluarga.disabilitas) {
      newError.disabilitas = "Gangguan Fungsional wajib diisi";
    }

    if (
      !selectedKeluarga.disabilitas ||
      selectedKeluarga.disabilitas.length === 0
    ) {
      newError.disabilitas = "Gangguan Fungsional wajib diisi";
    }

    // if (!selectedKeluarga.disabilitas && !selectedKeluarga.disabilitas?.length && !selectedKeluarga.disabilitas?.includes("5")) {
    //     newError.mengurus_diri = "Mengurus diri wajib diisi kecuali pilih 'Tidak'";
    // }

    if (!selectedKeluarga.mengurus_diri) {
      if (
        selectedKeluarga.disabilitas &&
        selectedKeluarga.disabilitas?.length &&
        !selectedKeluarga.disabilitas?.includes(5)
      ) {
        newError.mengurus_diri =
          "Mengurus diri wajib diisi kecuali pilih 'Tidak'";
      }
    }

    if (!selectedKeluarga.jenis_pekerjaan) {
      newError.jenis_pekerjaan = "Jenis Pekerjaan wajib diisi";
    } else if (
      +selectedKeluarga.jenis_pekerjaan !== 1 &&
      countAge(selectedKeluarga.tgl_lahir) < 6
    ) {
      // newError.jenis_pekerjaan = "Usia pekerja tidak boleh < 5 tahun";
      newError.jenis_pekerjaan =
        "Individu dengan status bekerja tidak boleh berusia < 5 tahun";
    }

    if (
      !selectedKeluarga.bekerja_luar_negeri &&
      countAge(selectedKeluarga.tgl_lahir) > 18
    ) {
      newError.bekerja_luar_negeri = "Bekerja di Luar Negeri wajib diisi";
    }

    if (
      !selectedKeluarga.sts_pekerjaan &&
      +selectedKeluarga.jenis_pekerjaan !== 0 &&
      +selectedKeluarga.jenis_pekerjaan !== 1 &&
      +selectedKeluarga.jenis_pekerjaan !== 10
    ) {
      newError.sts_pekerjaan = "Status Pekerjaan wajib diisi";
    }

    // if (wilayah.jumlah_keluarga !== "1") {
    //     if (!selectedKeluarga.keberadaan) {
    //         newError.keberadaan = "Keberadaan Anggota Keluarga wajib diisi";
    //     }
    // }

    // if (id === lastKeluarga) {
    //     let x = 0;
    //     Object.keys(keluarga).forEach(function (key) {
    //
    //         if (keluarga[key].keberadaan === "1") {
    //             x++
    //         }
    //     });

    //     if (x === 0) {
    //         newError.keberadaan = "Minimal terdapat 1 individu berada di dalam rumah";
    //     }
    // }
    return newError;
  };

  //
  //
  //
  //

  //

  useEffect(() => {
    if (isRefresh !== 0) {
      let label = [];
      let list = [];
      Object.keys(keluarga).forEach((el, index) => {
        label.push(keluarga[el].no_urutnik);
        list.push({
          content: (
            <Keluarga
              keluarga={keluarga}
              setKeluarga={setKeluarga}
              formIndex={index}
            />
          ),
        });
      });
    }
    setError({});
    statuskawin();
    validasired();
  }, [isRefresh]);

  const removeIndividu = () => {
    try {
      // ===== Delete individu aktif =====
      const filterObject = (obj, filter, filterValue) =>
        Object.keys(obj).reduce(
          (acc, val) =>
            obj[val][filter] === filterValue
              ? acc
              : {
                  ...acc,
                  [val]: obj[val],
                },
          {}
        );

      const klg = filterObject(keluarga, "no_urutnik", formIndex);

      setWilayah({
        ...wilayah,
        jumlah_keluarga: parseInt(wilayah.jumlah_keluarga) - 1 + "",
      });

      const individuDelete = keluarga[id];

      let newkeluarga = {};

      // ===== Update no urut & kd_ibukandung 0 =====
      const dt = Object.keys(klg);
      for (let i = 0; i < dt.length; i++) {
        newkeluarga[i + 1] = {
          ...klg[dt[i]],
          no_urutnik: i + 1,
          kd_ibukandung: 0,
        };
      }

      //

      // === Jika yg dihapus anak pertama krn status menikah, maka kd_ibukandung anak ke-dua bukan 0, tetap 1
      if (
        individuDelete.no_urutnik !== 1 &&
        +individuDelete.sts_hubungan === 3 &&
        +individuDelete.mutasi_anggota_keluarga === 1
      ) {
        const data_keluarga = Object.keys(newkeluarga);

        for (let i = 1; i <= data_keluarga.length; i++) {
          // ===== Update kd_ibukandung 1 =====
          if (newkeluarga[i].sts_hubungan === "3") {
            newkeluarga[i].kd_ibukandung = "1";
          } else if (newkeluarga[i].sts_hubungan === "4") {
            newkeluarga[i].kd_ibukandung = "0";
          }
        }
      }

      // ===== Jika yg dihapus Kepala Keluarga kawin atau istri =====
      if (
        (individuDelete.no_urutnik === 1 && +individuDelete.sts_kawin === 2) ||
        (individuDelete.no_urutnik === 2 && +individuDelete.sts_hubungan === 2)
      ) {
        newkeluarga["1"].sts_kawin = "4";
        newkeluarga["1"].sts_hubungan = "1";

        const data_keluarga = Object.keys(newkeluarga);

        for (let i = 1; i <= data_keluarga.length; i++) {
          // ===== Update kd_ibukandung 1 =====
          if (newkeluarga[i].sts_hubungan === "3") {
            newkeluarga[i].kd_ibukandung = "1";
          } else if (newkeluarga[i].sts_hubungan === "4") {
            newkeluarga[i].kd_ibukandung = "0";
          }
        }
      }

      // === Jika yg di hapus Kepala keluarga dengan sts_kawin Belum Kawin ===
      if (
        individuDelete.no_urutnik === 1 &&
        (+individuDelete.sts_kawin === 1 || +individuDelete.sts_kawin === 2)
      ) {
        newkeluarga["1"].sts_kawin = "";
        newkeluarga["1"].sts_hubungan = "1";

        // const data_keluarga = Object.keys(newkeluarga);

        // for (let i = 1; i <= data_keluarga.length; i++) {
        //     // ===== Update kd_ibukandung 1 =====
        //     if (newkeluarga[i].sts_hubungan === "3") {
        //         newkeluarga[i].kd_ibukandung = "1"
        //     } else if (newkeluarga[i].sts_hubungan === '4') {
        //         newkeluarga[i].kd_ibukandung = "0"
        //     }
        // }
      }

      // ===== Jika yg dihapus Kepala Keluarga berjenis kelamin perempuan =====
      if (
        (individuDelete.no_urutnik === 1 || individuDelete.no_urutnik === 2) &&
        (+individuDelete.sts_hubungan === 1 ||
          +individuDelete.sts_hubungan === 2)
      ) {
        if (+individuDelete.jenis_kelamin === "2") {
          const data_keluarga = Object.keys(newkeluarga);

          for (let i = 1; i <= data_keluarga.length; i++) {
            // ===== Update sts_hubungan 1 dan 4, dan update kd_ibukandung 0 =====
            if (i === 1) {
              newkeluarga[i].sts_hubungan = "1";
              newkeluarga[i].kd_ibukandung = "0";
            } else {
              newkeluarga[i].sts_hubungan = "4";
              newkeluarga[i].kd_ibukandung = "0";
            }
          }
        }
      }

      const data_klg = Object.keys(newkeluarga);
      for (let i = 1; i >= data_klg.length; i++) {
        if (newkeluarga[i].flagNew === true) {
          newkeluarga[i].flagNew = true;
        }
      }

      setKeluarga(newkeluarga);

      // ===== Jika yg dihapus last index ganti ke form selanjutnya =====
      for (let i = 1; i >= data_klg.length; i++) {
        if (newkeluarga[i].no_urutnik === +wilayah.jumlah_keluarga) {
          handleNext();
        } else {
          setIsRefresh(isRefresh);
        }
      }
    } catch (error) {}
  };

  const checkBeforeSubmit = (e) => {
    e.preventDefault();
    if (
      selectedKeluarga.mutasi_anggota_keluarga === "1" ||
      selectedKeluarga.mutasi_anggota_keluarga === "2"
    ) {
      Swal.fire({
        title: "Peringatan",
        text: "Data dengan mutasi anggota keluarga menikah/meninggal dunia akan dihapus.",
        icon: "warning",
        cancelButtonText: "Batal",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ya",
        confirmButtonColor: "#3085d6",
        showCancelButton: true,
      })
        .then((result) => {
          if (result.value) {
            removeIndividu();
          }
        })
        .catch((error) => {});
    } else {
      handleSubmit();
      const validation = validate(formIndex - 1);

      if (validation) {
        validate();
      } else {
        if (formIndex - 1 === 0) {
          // Set jenis_kelamin istri perempuan //
          if (
            +wilayah.jumlah_keluarga > 1 &&
            keluarga["1"].jenis_kelamin === "1" &&
            keluarga["1"].sts_kawin === 2
          ) {
            keluarga["2"].jenis_kelamin = "2";
            keluarga["2"].sts_kawin = 2;
            setKeluarga(keluarga);
          }
        }
        // if (isLastStep) {
        if (keluarga[id].no_urutnik === +wilayah.jumlah_keluarga) {
          handleNext();
        } else {
          return <Keluarga />;
        }
      }
    }
  };

  const handleSubmit = async (e) => {
    // e.preventDefault();
    const findErrors = validate();
    const errorValues = Object.values(findErrors);

    //jika jumlah keluarga nya hanya 1 orang maka langsung default di dalam rumah
    if (wilayah.jumlah_keluarga === "1") {
      setKeluarga({
        ...keluarga,
        [id]: {
          ...keluarga[id],
          // ["keberadaan"]: "1"
        },
      });
    }

    if (errorValues.length > 0 && errorValues.some((err) => err !== "")) {
      setError(findErrors);
    } else {
      if (!isSomethingChange) {
        return handleNext();
      }
      //simpan ke db local
      setSubmitting(true);
      try {
        setSubmitting(false);
        setSomethingChange(false);
        handleNext();
        //
        //
      } catch (e) {
        setSubmitting(false);
        if (e.name === "not_found") {
          try {
            // await dataKK.local.put({
            //     _id: id,
            //     type: 'anggota',
            //     ...selectedKeluarga
            // })

            setSomethingChange(false);
            handleNext();
          } catch (e) {
            enqueueSnackbar(e.message, { variant: "error" });
          }
        } else {
          enqueueSnackbar(e.message, { variant: "error" });
        }
      }
    }
  };

  let hubungan;
  if (keluarga["1"].sts_hubungan === undefined) {
    //
    hubungan = true;
  } else if (
    ["1", "2", "3", "4"].includes(selectedKeluarga.sts_hubungan) === true
  ) {
    //
    hubungan = true;
  } else {
    hubungan = false;
  }

  if (wilayah.jumlah_keluarga == 1) {
    if (keluarga["1"].sts_kawin == "2") {
      setKeluarga({
        ...keluarga,
        ["1"]: {
          ...keluarga["1"],
          ["sts_kawin"]: "",
        },
      });
    }
  }

  const value = keluarga;

  return (
    <Swipeable
    // trackMouse={true}
    // onSwipedRight={(e) => {

    //     if (backRef) {
    //         backRef.current.click()
    //     }
    // }}
    // onSwipedLeft={(e) => {
    //     if (nextRef) {

    //         nextRef.current.click();
    //     }
    // }}
    >
      <form onSubmit={checkBeforeSubmit} className={classes.form} noValidate>
        <ScrollToTopWithoutRouter />
        <Grid container spacing={3}>
          <Grid item xs={12} className={classes.textCenter}>
            <Typography variant="h5" component="h1">
              {mode === "edit"
                ? `Edit Form Data Kependudukan`
                : "Form Data Kependudukan"}
            </Typography>
            {/* {mode === 'edit' && <Typography>No KK: {no_kk}</Typography>} */}
          </Grid>

          <Grid item xs className={classes.textLeft}>
            {(mode === "edit" &&
              wilayah.status_draft &&
              wilayah.status_draft === "1") ||
            (Object.hasOwn(wilayah, "submit") && wilayah.submit === false) ? (
              <>
                {" "}
                <Button
                  color="primary"
                  variant="contained"
                  onClick={handleDraft("local", 1)}
                  disabled={isSubmitting.local || isSaved.local}
                  style={{ marginRight: "10px" }}
                >
                  <SaveIcon className={classes.iconLeft} /> Save as Draft{" "}
                </Button>{" "}
              </>
            ) : (
              <></>
            )}

            {mode === "edit" &&
            (wilayah.status_draft === undefined ||
              wilayah.status_draft === "2") ? (
              <>
                <FormControl variant="outlined">
                  <Select
                    id=""
                    value=""
                    name="segmen"
                    onChange={handleCheckSegmen}
                    displayEmpty
                    style={{ marginRight: "10px" }}
                  >
                    <MenuItem value=""> Segmen </MenuItem>
                    <MenuItem value="0"> Wilayah </MenuItem>
                    <MenuItem value="1"> Keluarga </MenuItem>
                    <MenuItem value="2"> KB </MenuItem>
                    <MenuItem value="3"> PK </MenuItem>
                    {/* <MenuItem value="4"> Stunting </MenuItem> */}
                  </Select>
                </FormControl>
              </>
            ) : (
              <></>
            )}

            {mode !== "edit" ? (
              <>
                {" "}
                <Button
                  color="primary"
                  variant="contained"
                  onClick={handleDraft("local", 1, null)}
                  disabled={isSubmitting.local || isSaved.local}
                >
                  <SaveIcon className={classes.iconLeft} /> Save as Draft{" "}
                </Button>{" "}
              </>
            ) : (
              <></>
            )}
          </Grid>

          <Grid item>
            {mode === "edit" && wilayah.status_sensus === "Anomali" ? (
              <>
                {" "}
                <Button
                  color="primary"
                  variant="contained"
                  onClick={handleAnomali("local", 1)}
                  disabled={isSubmitting.local || isSaved.local}
                >
                  <AssignmentTurnedInIcon /> Anomali Terkonfirmasi{" "}
                </Button>{" "}
              </>
            ) : (
              <></>
            )}
          </Grid>

          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={4} md={2}>
            <TextField
              // disabled={isSubmitting}
              disabled
              fullWidth
              variant="outlined"
              value={`No.${id}`}
              name="no_anggotakel"
              id="no_anggotakel"
              onChange={handleChange}
              error={error.no_anggotakel ? true : false}
              helperText={error.no_anggotakel}
              InputProps={{
                style: {
                  color: "#000000",
                  backgroundColor: "#f5f5f5",
                },
              }}
            />
          </Grid>

          <Grid item xs={8} md={5}>
            <TextField
              disabled={isSubmitting}
              fullWidth
              variant="outlined"
              style={{ textTransform: "uppercase" }}
              placeholder="Nama Anggota Keluarga"
              value={selectedKeluarga.nama_anggotakel || ""}
              name="nama_anggotakel"
              id="nama_anggotakel"
              inputProps={{
                min: 0,
                maxLength: 60,
              }}
              onChange={handleChangeUppercase}
              error={error.nama_anggotakel ? true : false}
              helperText={error.nama_anggotakel}
              autoComplete="off"
              onPaste={(e) => {
                e.preventDefault();
                return false;
              }}
            />
          </Grid>

          <Grid item xs={12} md={5}>
            <TextField
              disabled={isSubmitting}
              fullWidth
              variant="outlined"
              placeholder="NIK"
              value={selectedKeluarga.nik || ""}
              name="nik"
              id="nik"
              type="number"
              inputProps={{
                min: 0,
              }}
              onChange={handleChange}
              // classes={{ root: nikError ? classes.errorInput : "" }}
              error={error.nik ? true : false}
              helperText={error.nik}
              autoComplete="off"
              onPaste={(e) => {
                e.preventDefault();
                return false;
              }}
              style={{
                backgroundColor:
                  selectedKeluarga.tgl_lahir &&
                  countAge(selectedKeluarga.tgl_lahir) > 17 &&
                  String(selectedKeluarga.nik) === "9999999999999999"
                    ? "red"
                    : "transparent",
              }}
              InputProps={{
                style: {
                  backgroundColor:
                    selectedKeluarga.tgl_lahir &&
                    countAge(selectedKeluarga.tgl_lahir) > 17 &&
                    String(selectedKeluarga.nik) === "9999999999999999"
                      ? "red"
                      : "transparent",
                  color:
                    selectedKeluarga.tgl_lahir &&
                    countAge(selectedKeluarga.tgl_lahir) > 17 &&
                    String(selectedKeluarga.nik) === "9999999999999999"
                      ? "white"
                      : "inherit",
                },
              }}
            />
            {/* <FormHelperText>{error.nik}</FormHelperText> */}
          </Grid>

          <Grid item xs={12} md={4}>
            <FormControl
              disabled={
                isSubmitting ||
                (keluarga["1"].jenis_kelamin === "1" &&
                  (keluarga["1"].sts_kawin === "2" ||
                    keluarga["1"].sts_kawin === "3") &&
                  id === "2")
              }
              variant="outlined"
              fullWidth
              error={error.jenis_kelamin ? true : false}
            >
              <Select
                id="jenis_kelamin"
                value={
                  selectedKeluarga.jenis_kelamin ||
                  (keluarga["1"].jenis_kelamin === "1" &&
                    (keluarga["1"].sts_kawin === "2" ||
                      keluarga["1"].sts_kawin === "3") &&
                    id === "2" &&
                    "2") ||
                  ""
                }
                onChange={handleChange}
                name="jenis_kelamin"
                displayEmpty
              >
                <MenuItem value="">Pilih Jenis Kelamin</MenuItem>
                <MenuItem value="1">1. Laki Laki</MenuItem>
                <MenuItem value="2">2. Perempuan</MenuItem>
              </Select>
              <FormHelperText>{error.jenis_kelamin}</FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={4}>
            {/* <TextField
                            disabled={isSubmitting}
                            fullWidth
                            variant="outlined"
                            placeholder="Tanggal Lahir"
                            value={selectedKeluarga.tgl_lahir || ''}
                            name="tgl_lahir"
                            id="tgl_lahir"
                            type="date"
                            onChange={handleChange}
                            error={error.tgl_lahir ? true : false}
                            helperText={error.tgl_lahir}
                        /> */}
            <DatePicker
              autoOk
              fullWidth
              variant="inline"
              format={formatString}
              // label="Tanggal Lahir"
              // placeholder="Tanggal Lahir"
              name="tgl_lahir"
              id="tgl_lahir"
              disableFuture
              openTo="year"
              views={["year", "month", "date"]}
              inputVariant="outlined"
              emptyLabel="Tanggal Lahir"
              value={
                selectedKeluarga.tgl_lahir
                  ? parseDate(
                      selectedKeluarga.tgl_lahir,
                      formatString,
                      new Date()
                    )
                  : null
              }
              error={error.tgl_lahir ? true : false}
              helperText={error.tgl_lahir}
              //value={selectedDate}
              onChange={handleDateChange("tgl_lahir")}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <FormControl
              disabled={
                isSubmitting ||
                (keluarga["1"].jenis_kelamin === "1" &&
                  (keluarga["1"].sts_kawin === "2" ||
                    keluarga["1"].sts_kawin === "3") &&
                  id === "2")
              }
              variant="outlined"
              fullWidth
              error={error.sts_kawin ? true : false}
            >
              <Select
                id="sts_kawin"
                // value={selectedKeluarga.sts_kawin || '' }
                value={
                  selectedKeluarga.sts_kawin ||
                  (keluarga["1"].jenis_kelamin === "1" &&
                    keluarga["1"].sts_kawin === "2" &&
                    id === "2" &&
                    "2") ||
                  (keluarga["1"].jenis_kelamin === "1" &&
                    keluarga["1"].sts_kawin === "3" &&
                    id === "2" &&
                    "3") ||
                  ""
                }
                onChange={handleChange}
                name="sts_kawin"
                displayEmpty
              >
                <MenuItem value="">Status Perkawinan</MenuItem>
                <MenuItem value="1">1. Belum Kawin</MenuItem>
                {/* {
                                    (mode === 'edit' && id === "1" && keluarga['1'].jenis_kelamin === "2" && keluarga['1'].sts_hubungan === "1" ? <></> : <MenuItem value="1">1. Belum Kawin</MenuItem>)
                                } */}
                {/* {
                                    (wilayah.jumlah_keluarga != 1 && keluarga["01"].jenis_kelamin === "1" || keluarga["01"].sts_kawin !== "2" && id === "02") && <MenuItem value="2">Kawin</MenuItem>
                                } */}
                {parseInt(wilayah.jumlah_keluarga) === 1 ||
                (wilayah.jumlah_keluarga > 1 &&
                  keluarga["1"].jenis_kelamin === "2") ||
                (keluarga["1"].jenis_kelamin === "2" &&
                  keluarga["1"].sts_kawin === "2" &&
                  id === "2") ||
                (keluarga["1"].sts_kawin !== "2" && id === "2") ||
                (id !== "1" && id !== "2") ? (
                  <></>
                ) : (
                  <MenuItem value="2">2. Kawin Tercatat</MenuItem>
                )}
                {/* {
                                    (id === "1" && keluarga['1'].jenis_kelamin === "2" && keluarga['1'].sts_hubungan === "1" ? <MenuItem value="2">2. Kawin</MenuItem> : <></>)
                                } */}
                {parseInt(wilayah.jumlah_keluarga) === 1 ||
                (wilayah.jumlah_keluarga > 1 &&
                  keluarga["1"].jenis_kelamin === "2") ||
                (keluarga["1"].jenis_kelamin === "2" &&
                  keluarga["1"].sts_kawin === "3" &&
                  id === "2") ||
                (keluarga["1"].sts_kawin !== "3" && id === "2") ||
                (id !== "1" && id !== "2") ? (
                  <></>
                ) : (
                  <MenuItem value="3">3. Kawin Belum Tercatat</MenuItem>
                )}
                <MenuItem value="4">4. Cerai Hidup Tercatat</MenuItem>
                <MenuItem value="5">5. Cerai Hidup Belum Tercatat</MenuItem>
                <MenuItem value="6">6. Cerai Mati</MenuItem>
              </Select>
              <FormHelperText>{error.sts_kawin}</FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              // disabled={isSubmitting || !['2', '3', '4'].includes(selectedKeluarga.sts_kawin) || (keluarga["01"].jenis_kelamin === "1" && keluarga["01"].sts_kawin === "2" && id !== "01" && id !== "02")}
              disabled={
                isSubmitting ||
                !["2", "3", "4", "5", "6"].includes(selectedKeluarga.sts_kawin)
              }
              fullWidth
              variant="outlined"
              placeholder="Usia Kawin Pertama"
              value={
                ["2", "3", "4", "5", "6"].includes(selectedKeluarga.sts_kawin)
                  ? selectedKeluarga.usia_kawin === undefined
                    ? ""
                    : selectedKeluarga.usia_kawin
                  : ""
              }
              // value={['2', '3', '4'] ? (selectedKeluarga.usia_kawin == undefined ? '' : selectedKeluarga.usia_kawin) : ''}
              name="usia_kawin"
              id="usia_kawin"
              type="number"
              inputProps={{
                min: 0,
                max: umurnikah,
              }}
              onChange={handleChange}
              error={error.usia_kawin ? true : false}
              helperText={error.usia_kawin}
              autoComplete="off"
              onPaste={(e) => {
                e.preventDefault();
                return false;
              }}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <FormControl
              disabled={isSubmitting}
              variant="outlined"
              fullWidth
              error={error.sts_akta ? true : false}
            >
              <Select
                id="sts_akta"
                value={selectedKeluarga.sts_akta || ""}
                onChange={handleChangeStsAkta}
                name="sts_akta"
                displayEmpty
              >
                <MenuItem value="">Memiliki Akta Lahir</MenuItem>
                <MenuItem value="1">1. Ya</MenuItem>
                <MenuItem value="2">2. Tidak</MenuItem>
              </Select>
              <FormHelperText>{error.sts_akta}</FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={4}>
            <FormControl
              // disabled={isSubmitting || id === "1" || (keluarga['1'].jenis_kelamin === "1" && keluarga['1'].sts_kawin === "2" && id === "2")}
              // disabled={isSubmitting || id === "1" || (keluarga['1'].jenis_kelamin === "1" && keluarga['1'].sts_kawin === "2" && id === "2") ||
              //     (mode === "edit" && selectedKeluarga.flagNew === false && keluarga['1'].jenis_kelamin === "2" && (keluarga['1'].sts_kawin === "3" || keluarga['1'].sts_kawin === "4")) ||
              //     (mode === "edit" && selectedKeluarga.flagNew === false && (keluarga['1'].jenis_kelamin === "1" || keluarga['1'].jenis_kelamin === "2") && keluarga['1'].sts_kawin === "1")
              // }
              disabled={
                isSubmitting ||
                id === "1" ||
                (keluarga["1"].jenis_kelamin === "1" &&
                  (keluarga["1"].sts_kawin === "2" ||
                    keluarga["1"].sts_kawin === "3") &&
                  id === "2") ||
                (keluarga["1"].sts_kawin === 1 &&
                  keluarga["1"].jenis_kelamin === "1")
              }
              variant="outlined"
              fullWidth
              error={error.sts_hubungan ? true : false}
            >
              <Select
                id="sts_hubungan"
                value={
                  selectedKeluarga.sts_hubungan ||
                  (id === "1" && "1") ||
                  (keluarga["1"].jenis_kelamin === "1" &&
                    (keluarga["1"].sts_kawin === "2" ||
                      keluarga["1"].sts_kawin === "3") &&
                    id === "2" &&
                    "2") ||
                  ""
                }
                onChange={handleChangeHubungan}
                name="sts_hubungan"
                displayEmpty
                inputProps={{
                  style: {
                    color: "#000000 !important",
                    backgroundColor: "white",
                  },
                }}
                style={{
                  color: "#000000",
                  backgroundColor: "white",
                }}
              >
                <MenuItem value="">Hubungan Dengan Kepala Keluarga</MenuItem>
                {/* default halaman pertama kepala keluarga */}
                {/* {
                                    id === "1" && <MenuItem value="1">1. Kepala Keluarga</MenuItem>
                                } */}

                {/* jika halaman pertamanya seorang laki2 dan berstatus kawin maka default halaman ke duanya harus istri */}
                {/* {
                                    keluarga['1'].jenis_kelamin === "1" && keluarga['1'].sts_kawin === "2" && id === "2" &&
                                    <MenuItem value="2">2. Istri</MenuItem>
                                } */}

                {/* jika halaman keduanya default istri maka halaman seterusnya harus anak dan lainnya */}
                {/* {
                                    keluarga['1'].jenis_kelamin === "1" && keluarga['1'].sts_kawin === "2" && id > 2 &&
                                    itemHubungan.map((val, index) => {
                                        return (<MenuItem value={`${index + 3}`}>{val == "Anak" ? '3. ' : '4. '}{val}</MenuItem>)
                                    })
                                } */}

                {/* jika halaman pertama seorang perempuan dan berstatus kawin halaman ke dua dan seterusnya harus anak dan lainnya */}
                {/* {
                                    keluarga['1'].jenis_kelamin === "2" && keluarga['1'].sts_kawin === "2" && id >= 2 &&
                                    itemHubungan.map((val, index) => {
                                        return (<MenuItem value={`${index + 3}`}>{val == "Anak" ? '3. ' : '4. '}{val}</MenuItem>)
                                    })
                                } */}

                {/* jika halaman pertamanya cerai maka yg tampil di halaman ke dua dan seterusnya harus anak dan lainnya */}
                {/* {
                                    (keluarga['1'].sts_kawin === "3" || keluarga['1'].sts_kawin === "4") && id >= 2 &&
                                    itemHubungan.map((val, index) => {
                                        return (<MenuItem value={`${index + 3}`}>{val == "Anak" ? '3. ' : '4. '}{val}</MenuItem>)
                                    })
                                } */}

                {/* jika halaman pertamanya belum kawin maka yg tampil di halaman ke dua dan seterusnya lainnya */}
                {/* {
                                    keluarga['1'].sts_kawin === "1" && id >= 2 &&
                                    itemHubungan.map((val, index) => {
                                        return (<MenuItem value={`${index + 3}`}>{val == "Anak" ? '3. ' : '4. '}{val}</MenuItem>)
                                    })
                                } */}

                {/* jika halaman pertamanya belum kawin atau sudah tidak memiliki orang tua maka yg tampil di halaman ke dua dan seterusnya lainnya */}
                {/* {
                                    keluarga['1'].sts_kawin === "1" && keluarga['1'].sts_hubungan === "1" && id >= 2 &&
                                    itemHubungan.map((val, index) => {
                                        return (<MenuItem value={`${index + 3}`}>{val == "Lainnya" ? '4. ' : ''}{val}</MenuItem>)
                                    })
                                } */}

                {optHubungan.length > 0 &&
                  optHubungan.map((el) => {
                    return <MenuItem value={el.value}>{el.label}</MenuItem>;
                  })}
              </Select>
              <FormHelperText>{error.sts_hubungan}</FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={4}>
            <FormControl
              // disabled={isSubmitting || selectedKeluarga.sts_hubungan !== "3"}
              disabled={
                isSubmitting ||
                selectedKeluarga.sts_hubungan !== "3" ||
                // (mode === "edit" && keluarga['1'].jenis_kelamin === "2" && (keluarga['1'].sts_kawin === "3" || keluarga['1'].sts_kawin === "4")) ||
                (mode === "edit" &&
                  (keluarga["1"].jenis_kelamin === "1" ||
                    keluarga["1"].jenis_kelamin === "2") &&
                  keluarga["1"].sts_kawin === "1")
              }
              variant="outlined"
              fullWidth
              error={error.kd_ibukandung ? true : false}
            >
              {/* {} */}
              {/* {} */}
              <Select
                id="kd_ibukandung"
                value={
                  selectedKeluarga.sts_hubungan === "3" &&
                  keluarga["2"].sts_hubungan === "2"
                    ? selectedKeluarga.kd_ibukandung
                    : selectedKeluarga.sts_hubungan === "3" &&
                      keluarga["1"].jenis_kelamin === "2"
                    ? selectedKeluarga.kd_ibukandung === undefined
                      ? ""
                      : selectedKeluarga.kd_ibukandung
                    : selectedKeluarga.sts_hubungan === "3" &&
                      keluarga["1"].jenis_kelamin === "1"
                    ? "0"
                    : ""
                  // (selectedKeluarga?.sts_hubungan === "1" && (keluarga['1']?.jenis_kelamin === "1" || keluarga['1']?.jenis_kelamin === "2") && keluarga['1'].sts_kawin === "1") ? '0' : ''
                }
                onChange={handleChange}
                name="kd_ibukandung"
                displayEmpty
              >
                <MenuItem value="">Kode Ibu Kandung</MenuItem>
                {/* {
                                    Object.values(keluarga).map(kel => {
                                        if (Object.keys(keluarga).length > 1) {
                                            if (kel.sts_hubungan == "1" && kel.sts_kawin == "2" && kel.jenis_kelamin == "1") {
                                                return (
                                                    <MenuItem key={keluarga['2'].no_urutnik} value={keluarga['2'].no_urutnik}>{keluarga['2'].no_urutnik} - {keluarga['2'].nama_anggotakel}</MenuItem>
                                                )
                                            }

                                            if (kel.sts_hubungan == "1" && kel.sts_kawin !== "2" && kel.jenis_kelamin == "2") {
                                                return (
                                                    <MenuItem key={keluarga['1'].no_urutnik} value={keluarga['1'].no_urutnik}>{keluarga['1'].no_urutnik} - {keluarga['1'].nama_anggotakel}</MenuItem>
                                                )
                                            }

                                            if (kel.sts_hubungan == "1" && (kel.sts_kawin == "3" || kel.sts_kawin == "4") && kel.jenis_kelamin == "1") {
                                                // return (
                                                //     <MenuItem value="0">00</MenuItem>
                                                // )
                                                return null
                                            }

                                            // if (kel.sts_hubungan == "1" && (kel.sts_kawin == "3" || kel.sts_kawin == "4") && kel.jenis_kelamin == "2") {
                                            //     return (
                                            //         <MenuItem key={keluarga['1'].no_urutnik} value={keluarga['1'].no_urutnik}>{keluarga['1'].no_urutnik} - {keluarga['1'].nama_anggotakel}</MenuItem>
                                            //     )
                                            // }

                                            // if (kel.sts_hubungan == "1" && kel.sts_kawin == "1" && (kel.jenis_kelamin == "1" || kel.jenis_kelamin == "1")) {
                                            //     return (
                                            //         <MenuItem value="0">00 -</MenuItem>
                                            //     )
                                            // }
                                        }
                                    })
                                }
                                <MenuItem value="0">00 -</MenuItem> */}

                {optKodeIbuKandung.length > 0 &&
                  optKodeIbuKandung.map((el) => {
                    return <MenuItem value={el.value}>{el.label}</MenuItem>;
                  })}
              </Select>
              <FormHelperText>{error.kd_ibukandung}</FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <FormControl
              disabled={isSubmitting}
              variant="outlined"
              fullWidth
              error={error.id_agama ? true : false}
            >
              <Select
                id="id_agama"
                value={selectedKeluarga.id_agama || ""}
                onChange={handleChange}
                name="id_agama"
                displayEmpty
              >
                <MenuItem value="">Agama</MenuItem>
                <MenuItem value="1">1. Islam</MenuItem>
                <MenuItem value="2">2. Kristen</MenuItem>
                <MenuItem value="3">3. Katolik</MenuItem>
                <MenuItem value="4">4. Hindu</MenuItem>
                <MenuItem value="5">5. Budha</MenuItem>
                <MenuItem value="6">6. Konghucu</MenuItem>
                <MenuItem value="7">7. Penghayat Kepercayaan</MenuItem>
                {/* <MenuItem value="8">8. Lainnya</MenuItem> */}
              </Select>
              <FormHelperText>{error.id_agama}</FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <FormControl
              disabled={isSubmitting}
              variant="outlined"
              fullWidth
              error={error.jenis_pekerjaan ? true : false}
            >
              <Select
                id="jenis_pekerjaan"
                value={selectedKeluarga.jenis_pekerjaan || ""}
                onChange={handleChange}
                name="jenis_pekerjaan"
                displayEmpty
              >
                <MenuItem value="">Jenis Pekerjaan</MenuItem>
                <MenuItem value="1">1. Tidak/Belum Bekerja</MenuItem>
                <MenuItem value="2">2. Petani</MenuItem>
                <MenuItem value="3">3. Nelayan</MenuItem>
                <MenuItem value="4">4. Pedagang</MenuItem>
                <MenuItem value="5">5. Pejabat Negara/Kepala Wilayah</MenuItem>
                <MenuItem value="6">6. PNS/TNI/POLRI</MenuItem>
                <MenuItem value="7">7. Swasta Sektor Pertanian</MenuItem>
                <MenuItem value="8">8. Swasta Sektor Industri</MenuItem>
                <MenuItem value="9">9. Swasta Sektor Jasa</MenuItem>
                <MenuItem value="10">10. Pensiunan</MenuItem>
                <MenuItem value="11">11. Pekerja Lepas</MenuItem>
              </Select>
              <FormHelperText>{error.jenis_pekerjaan}</FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6}>
            <FormControl
              disabled={
                isSubmitting ||
                !selectedKeluarga.tgl_lahir ||
                countAge(selectedKeluarga.tgl_lahir) < 18
              }
              variant="outlined"
              fullWidth
              error={error.bekerja_luar_negeri ? true : false}
            >
              <Select
                id="bekerja_luar_negeri"
                value={selectedKeluarga.bekerja_luar_negeri || ""}
                onChange={handleChange}
                name="bekerja_luar_negeri"
                displayEmpty
              >
                <MenuItem value="">Pilih Bekerja di Luar Negeri</MenuItem>
                {optKerjaLuarNegeri.map((el) => {
                  return <MenuItem value={el.value}>{el.label}</MenuItem>;
                })}
              </Select>
              <FormHelperText>{error.bekerja_luar_negeri}</FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6}>
            <FormControl
              disabled={
                isSubmitting ||
                !selectedKeluarga.jenis_pekerjaan ||
                selectedKeluarga.jenis_pekerjaan?.lenght === 0 ||
                +selectedKeluarga.jenis_pekerjaan === 1 ||
                +selectedKeluarga.jenis_pekerjaan === 5 ||
                +selectedKeluarga.jenis_pekerjaan === 6 ||
                +selectedKeluarga.jenis_pekerjaan === 10
              }
              variant="outlined"
              fullWidth
              error={error.sts_pekerjaan ? true : false}
            >
              <Select
                id="sts_pekerjaan"
                value={selectedKeluarga.sts_pekerjaan || ""}
                onChange={handleChange}
                name="sts_pekerjaan"
                displayEmpty
              >
                <MenuItem value="">Status Pekerjaan</MenuItem>
                {optStsPekerjaan.map((el) => {
                  return <MenuItem value={el.value}>{el.label}</MenuItem>;
                })}
              </Select>
              <FormHelperText>{error.sts_pekerjaan}</FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6}>
            <FormControl
              disabled={isSubmitting}
              variant="outlined"
              fullWidth
              error={error.jns_pendidikan ? true : false}
            >
              <Select
                id="jns_pendidikan"
                value={selectedKeluarga.jns_pendidikan || ""}
                onChange={handleChange}
                name="jns_pendidikan"
                displayEmpty
              >
                <MenuItem value="">Pendidikan</MenuItem>
                {optJnsPendidikan.map((el) => {
                  return <MenuItem value={el.value}>{el.label}</MenuItem>;
                })}
              </Select>
              <FormHelperText>{error.jns_pendidikan}</FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6}>
            <FormControl
              disabled={isSubmitting}
              variant="outlined"
              fullWidth
              error={error.jns_asuransi ? true : false}
            >
              <Select
                id="jns_asuransi"
                value={selectedKeluarga.jns_asuransi || ""}
                onChange={handleChangeJnsAsuransi}
                name="jns_asuransi"
                displayEmpty
              >
                <MenuItem value="">
                  Kepesertaan JKN/Asuransi Kesehatan lainnya
                </MenuItem>
                <MenuItem value="1">1. BPJS-PBI/Jamkesmas/Jamkesda</MenuItem>
                <MenuItem value="2">2. BPJS-Non PBI</MenuItem>
                <MenuItem value="3">3. Swasta</MenuItem>
                <MenuItem value="4">4. Tidak Memiliki</MenuItem>
              </Select>
              <FormHelperText>{error.jns_asuransi}</FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={12}>
            <FormControl
              disabled={
                isSubmitting ||
                selectedKeluarga?.cfm === true ||
                selectedKeluarga?.cfm === 1
              }
              variant="outlined"
              fullWidth
              error={error.disabilitas ? true : false}
            >
              <InputLabel
                id="disabilitas-label"
                shrink={false}
                style={{
                  transform: "translate(14px, 20px) scale(1)",
                  color:
                    selectedKeluarga?.disabilitas?.length > 0
                      ? "transparent"
                      : "#999",
                }}
              >
                {selectedKeluarga?.disabilitas?.length === 0 &&
                  "Mengalami Gangguan Fungsional (Disabilitas)"}
              </InputLabel>
              <Select
                id="disabilitas"
                value={
                  wilayah?.cfm === true || wilayah?.cfm === 1
                    ? [5]
                    : selectedKeluarga?.disabilitas ?? [""]
                }
                onChange={handleChange}
                name="disabilitas"
                disabled={wilayah?.cfm === true || wilayah?.cfm === 1}
                displayEmpty
                multiple
              >
                <MenuItem disabled value="" className={classes.menuItem}>
                  Mengalami Gangguan Fungsional (Disabilitas)
                </MenuItem>
                <MenuItem value={1} className={classes.menuItem}>
                  1. Fisik
                </MenuItem>
                <MenuItem value={2} className={classes.menuItem}>
                  2. Sensorik
                </MenuItem>
                <MenuItem value={3} className={classes.menuItem}>
                  3. Mental
                </MenuItem>
                <MenuItem value={4} className={classes.menuItem}>
                  4. Intelektual
                </MenuItem>
                <MenuItem value={5} className={classes.menuItem}>
                  5. Tidak
                </MenuItem>
              </Select>
              {selectedKeluarga?.disabilitas?.includes(
                5
              ) ? null : selectedKeluarga?.disabilitas?.length > 0 ? (
                <FormHelperText style={{ color: "red" }}>
                  Bisa lebih dari satu jawaban
                </FormHelperText>
              ) : (
                <FormHelperText>{error.disabilitas}</FormHelperText>
              )}
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6}>
            <FormControl
              disabled={
                isSubmitting ||
                !selectedKeluarga?.disabilitas?.length ||
                (selectedKeluarga?.disabilitas ?? []).includes(5)
              }
              variant="outlined"
              fullWidth
              error={error.mengurus_diri ? true : false}
            >
              <Select
                id="mengurus_diri"
                value={selectedKeluarga.mengurus_diri ?? ""}
                onChange={handleChange}
                name="mengurus_diri"
                displayEmpty
              >
                <MenuItem value="">Kemampuan Mengurus Diri Sendiri</MenuItem>
                <MenuItem value={1}>
                  1. Tidak Dapat Mengurus Diri Sendiri
                </MenuItem>
                <MenuItem value={2}>2. Banyak Mengalami Kesulitan</MenuItem>
                <MenuItem value={3}>3. Sedikit Mengalami Kesulitan</MenuItem>
                <MenuItem value={4}>4. Tidak Mengalami Kesulitan</MenuItem>
              </Select>
              <FormHelperText>{error.mengurus_diri}</FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6}>
            <FormControl
              disabled={isSubmitting || wilayah.sts_keluarga === "5"}
              variant="outlined"
              fullWidth
              error={error.mutasi_anggota_keluarga ? true : false}
            >
              <Select
                id="mutasi_anggota_keluarga"
                value={selectedKeluarga.mutasi_anggota_keluarga || ""}
                onChange={handleChangeMutasiAnggotaKeluarga}
                name="mutasi_anggota_keluarga"
                displayEmpty
              >
                <MenuItem value="">Mutasi Anggota Keluarga</MenuItem>
                {optMutasiAnggotaKeluarga.length > 0 &&
                  optMutasiAnggotaKeluarga.map((el) => {
                    return <MenuItem value={el.value}>{el.label}</MenuItem>;
                  })}

                {/* {(selectedKeluarga.sts_hubungan === '3' || selectedKeluarga.sts_hubungan === '4') &&
                                    <MenuItem value="1">1. Menikah</MenuItem>
                                }
                                <MenuItem value="2">2. Meninggal Dunia</MenuItem>
                                <MenuItem value="3">3. Anggota Baru</MenuItem> */}
              </Select>
              <FormHelperText>{error.mutasi_anggota_keluarga}</FormHelperText>
            </FormControl>
          </Grid>

          {/* <Grid item xs={12} md={6}>
                        <FormControl
                            disabled={isSubmitting || wilayah.jumlah_keluarga === "1"}
                            variant="outlined" fullWidth error={error.keberadaan ? true : false}>

                            <Select
                                id="keberadaan"
                                value={((wilayah.jumlah_keluarga === "1" && "1")) || selectedKeluarga.keberadaan || ""}
                                onChange={handleChange}
                                name="keberadaan"
                                displayEmpty
                            >
                                <MenuItem value="">Keberadaan anggota keluarga</MenuItem>
                                {
                                    wilayah.jumlah_keluarga === "1" && <MenuItem value="1">Menikah</MenuItem>
                                }
                                {
                                    wilayah.jumlah_keluarga !== "1" &&
                                    itemKeberadaan.map((val, index) => {
                                        return (<MenuItem value={`${index + 1}`}>{`${index + 1}. `}{val}</MenuItem>)
                                    })
                                }
                            </Select>
                            <FormHelperText>{error.keberadaan}</FormHelperText>
                        </FormControl>
                    </Grid> */}

          <Grid item xs>
            <Button
              ref={backRef}
              // disabled={!isSomethingChange || isSubmitting}
              onClick={() => {
                handleBack();
              }}
            >
              <ChevronLeft className={classes.iconLeft} /> Sebelumnya{" "}
            </Button>
          </Grid>

          {/* <Grid item xs>
                        {
                            mode === "edit" && wilayah.status_draft && wilayah.status_draft === '1' ?
                                <> <Button
                                    color="primary"
                                    variant="contained"
                                    onClick={handleDraft('local', 1)}
                                    disabled={isSubmitting.local || isSaved.local}
                                >
                                    <SaveIcon className={classes.iconLeft} /> Save as Draft </Button> </> : <></>
                        }

                        {
                            mode == "edit" && (wilayah.status_draft == undefined || wilayah.status_draft == '2') ?
                                <>
                                    <FormControl
                                        variant="outlined">
                                        <Select
                                            id=""
                                            value=""
                                            name="segmen"
                                            onChange={handleCheckSegmen}
                                            displayEmpty
                                        >
                                            <MenuItem value=""> Segmen </MenuItem>
                                            <MenuItem value="0"> Wilayah </MenuItem>
                                            <MenuItem value="1"> Keluarga </MenuItem>
                                            <MenuItem value="2"> KB </MenuItem>
                                            <MenuItem value="3"> PK </MenuItem>
                                        </Select>
                                    </FormControl>
                                </> : <></>
                        }

                        {
                            mode !== "edit" ?
                                <> <Button
                                    color="primary"
                                    variant="contained"
                                    onClick={handleDraft('local', 1, null)}
                                    disabled={isSubmitting.local || isSaved.local}
                                >
                                    <SaveIcon className={classes.iconLeft} /> Save as Draft </Button> </> : <></>
                        }
                    </Grid> */}

          <Grid item>
            {isSubmitting && <CircularProgress size={14} />}
            <Button ref={nextRef} disabled={isSubmitting} type="submit">
              Selanjutnya <ChevronRight className={classes.iconRight} />
            </Button>
          </Grid>
        </Grid>
      </form>
    </Swipeable>
  );
}

Keluarga.propTypes = {
  id: PropTypes.string.isRequired,
  keluarga: PropTypes.object.isRequired,
  setKeluarga: PropTypes.func.isRequired,
};

export default Keluarga;
